"use client";

// React & Nextjs imports
import React, { useEffect } from "react";

// Hooks & Utils
import useMobile from "@/app/hooks/use-mobile";

// UI Components
import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";

// Icons
import ErrorIcon from "@/app/assets/icons/error-icon";

interface ErrorProps {
    error?: Error;
    reset?: () => void;
}

export default function Error({ error }: ErrorProps) {
    const { isMobile } = useMobile();

    useEffect(() => {
        console.error("An error occurred:", error);
    }, [error]);

    return (
        <div className="mx-auto flex min-h-screen flex-col items-center justify-center">
            <h1 className="mx-4 mb-4 text-center text-xl font-bold md:text-3xl">
                Sorry, something went wrong.
            </h1>
            <ErrorIcon />
            <p className="mt-4 text-gray-700">{error?.message}</p>
            <div className="mt-5 flex flex-col items-center space-y-4 md:flex-row md:space-x-4 md:space-y-0">
                <RegularButton
                    size={isMobile ? ButtonSize.Medium : ButtonSize.Large}
                    variant={ButtonVariant.PrimaryDefault}
                    onClick={() => (window.location.href = process.env.ICM_UE_POST_URL_LISTING ?? "")}
                    noIcon
                    showRightIcon={false}
                    label={"Home"}
                />
                <RegularButton
                    size={isMobile ? ButtonSize.Medium : ButtonSize.Large}
                    variant={ButtonVariant.SecondaryDefault}
                    onClick={() => window.location.reload()}
                    noIcon
                    showRightIcon={false}
                    label={"Try again"}
                />
            </div>
        </div>
    );
}
